import styled from "styled-components";

export const StyledTermsMainDiv = styled.div`
  font-size: 16px;
  margin: 20px;
  li{
    list-style-type: circle;
  }
`;